<template>
  <v-sheet color="grey700" class="py-7 px-8 rounded-0">
    <h4
      class="green500--text font-weight-bold text-uppercase text-body-1"
      v-text="'Pick an amount'"
    />
    <p
      class="text-body-2 green100--text"
      v-text="'You will be redirected to Kinguin.com'"
    />

    <div v-if="bonus" class="mb-3 green700 font-weight-bold text-center green100--text text-caption py-3">
      +{{ bonus * 100 | toLocale }}% bonus will be applied when you redeem the giftcard.
    </div>

    <v-row dense>
      <v-col v-for="card in cards" :key="card.value" cols="12" md="6">
        <v-card
          class="link"
          tile :ripple="false" flat
          target="_blank" rel="noopener noreferrer"
          :href="card.url" @click="onClick"
        >
          <v-img :src="require(`@/assets/img/giftcards/${card.value}.jpg`)" />
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      default: null,
    },
  },
  computed: {
    bonus() {
      return this.payload.bonus ?? 0
    },
    cards() {
      return [
        { value: 5, url: 'https://www.kinguin.net/category/92002/bandit-camp-5-scrap-gift-card' },
        { value: 10, url: 'https://www.kinguin.net/category/92279/bandit-camp-10-scrap-gift-card' },
        { value: 25, url: 'https://www.kinguin.net/category/92280/bandit-camp-25-scrap-gift-card' },
        { value: 50, url: 'https://www.kinguin.net/category/92282/bandit-camp-50-scrap-gift-card' },
        { value: 100, url: 'https://www.kinguin.net/category/92285/bandit-camp-100-scrap-gift-card' },
        { value: 250, url: 'https://www.kinguin.net/category/92286/bandit-camp-250-scrap-gift-card' },
        { value: 500, url: 'https://www.kinguin.net/category/92287/bandit-camp-500-scrap-gift-card' },
      ]
    },
  },
  methods: {
    onClick() {
      this.$modal.open('giftcard-redeem', { maxWidth: 400 })
      this.close()
    },
  },
}
</script>
